'use strict';

angular.module('mvpcarrefourApp')
    .controller('MyVotesController', ['$scope', '$rootScope', 'Vote', 'Auth', '$state',
        function ($scope, $rootScope, Vote, Auth, $state) {

            // Redirigir al usuario al inicio si no está autenticado
            if (!Auth.isLoggedIn()) {
                return $state.go('main');
            }

            // Inicializar variables del scope
            $scope.misvotos = []; // Todos los votos
            $scope.categories = []; // Categorías con conteo
            $scope.filteredVotes = []; // Productos filtrados por categoría seleccionada
            $scope.showCategories = false; // Controla el despliegue de las categorías

            // Alternar el despliegue de las categorías
            $scope.toggleCategories = function () {
                $scope.showCategories = !$scope.showCategories;
            };
            // Función recursiva para obtener la categoría principal
            function getRootCategory(category) {
                if (!category.parent) {
                    return category;
                }
                return getRootCategory(category.parent);
            }

            // Agrupar votos por categoría principal
            function groupVotesByCategory(votes) {
                const categoryMap = {};

                votes.forEach(vote => {
                    const rootCategory = getRootCategory(vote.product.categories[0]);
                    const categoryId = rootCategory._id;

                    if (!categoryMap[categoryId]) {
                        categoryMap[categoryId] = {
                            id: categoryId,
                            name: rootCategory.name,
                            count: 0
                        };
                    }
                    categoryMap[categoryId].count++;
                });

                // Convertir el mapa en una lista para usar en el HTML
                $scope.categories = Object.values(categoryMap);
            }

            // Filtrar productos por categoría seleccionada
            $scope.filterByCategory = function (category) {
                if (!category || !category.id) {
                    // Si no se proporciona una categoría válida, mostrar todos los productos
                    $scope.filteredVotes = $scope.misvotos;
                } else {
                    $scope.filteredVotes = $scope.misvotos.filter(vote => {
                        const rootCategory = getRootCategory(vote.product.categories[0]);
                        return rootCategory._id === category.id;
                    });
                }
            };

            // Cargar los votos del usuario
            if ($rootScope.currentUser._id != null) {
                Vote.myVotes($rootScope.currentUser._id, "full").then(function (result) {
                    $scope.misvotos = result;

                    // Agrupar los votos por categoría y calcular los conteos
                    groupVotesByCategory($scope.misvotos);

                    // Mostrar todos los productos inicialmente
                    $scope.filteredVotes = $scope.misvotos;

                    console.log("Votos agrupados por categoría:", $scope.categories);
                });
            }
        }
    ]);
